import firebaseInstance from "../util/firebase";
import firebase from "firebase";
import router from "../router";
import axios from "axios";
import _ from "lodash";
import SortedActions from "./actions/index.js";

export const actions = {
  ...SortedActions
};
